import { Question, TemplateField, TemplateValue, QuestionWithFields, QuestionType } from '@shared/types/database'

export function renderQuestions (
  templateQuestions: Question[],
  templateFields: Record<string, TemplateField>,
  templateFieldValues: Record<string, TemplateValue>
) {
  return templateQuestions.map(question => {
    return renderQuestion(question, templateFields, templateFieldValues)
  })
}

function renderQuestion (
  question: Question,
  templateFields: Record<string, TemplateField>,
  templateFieldValues: Record<string, TemplateValue>
) {
  if ('templateFields' in question) {
    question.label = renderLabel(question, templateFields, templateFieldValues)
    if ((question.questionType === 'rate-only' && question.custom) || (question.questionType === 'matrix-likert' && question.edited)) {
      question.scale = renderScale(question, templateFieldValues)
    }
    if (question.questionType === 'matrix-likert' && question.edited) {
      question.answers = renderAnswers(question, templateFieldValues)
    }
  }
  const isVariantQuestion = Object.keys(templateFieldValues).filter(key => key.split('-').includes('variant')).length
  if (isVariantQuestion && question.splitTestCapable) {
    question.questionType = QuestionType.Variant
  }
  return question
}

function renderLabel (
  question: QuestionWithFields,
  templateFields: Record<string, TemplateField>,
  templateFieldValues: Record<string, TemplateValue>
) {
  // Process each question by inserting the input value into the question label where needed
  return question.templateFields.reduce((acc, field) => {
    // Prepend any text values to labels
    const appendTextToLabel = ['input', 'textarea'].includes(templateFields[field.id!].type!) && ['append', 'prepend'].includes(field.placement!) && templateFieldValues[field.id!].value && !templateFieldValues[field.id!].variant
    if (appendTextToLabel) {
      acc = field.placement === 'prepend' ? [`${templateFieldValues[field.id!].value}<br><br>`, acc].join('') : [acc, `<br><br>${templateFieldValues[field.id!].value}`].join('')
    }
    // Find the next instance of {{slot}} and replace with the templateField value to update the the label value for each question
    if (['input', 'textarea'].includes(templateFields[field.id!].type!) && ['inline'].includes(field.placement!) && templateFieldValues[field.id!] && templateFieldValues[field.id!].value) {
      acc = acc.replace('{{slot}}', templateFieldValues[field.id!].value as string)
    } else if (!['input', 'textarea'].includes(templateFields[field.id!].type!)) {
      // Just Remove slot if templateField type is asset/url, alpha nlp will append later
      acc = acc.replace('{{slot}}', '')
    }
    return acc
  }, question.label)
}

function renderAnswers (question: QuestionWithFields, templateFieldValues: Record<string, TemplateValue>) {
  const listId = question.templateFields.find(templateField => templateField.id?.includes('list'))?.id as string
  const listValues = templateFieldValues[listId].value as any[]
  const answersArray = listValues.map((value: string) => ({ label: value }))
  return answersArray
}

function renderScale (question: QuestionWithFields, templateFieldValues: Record<string, TemplateValue>) {
  const minRatingId = question.templateFields.find(field => field.placement === 'min-rating')!.id!
  const maxRatingId = question.templateFields.find(field => field.placement === 'max-rating')!.id!
  const minRating = templateFieldValues[minRatingId].value as number
  const maxRating = templateFieldValues[maxRatingId].value as number
  const minLabelId = question.templateFields.find(field => field.placement === 'min-label')!.id!
  const maxLabelId = question.templateFields.find(field => field.placement === 'max-label')!.id!
  const minLabel = templateFieldValues[minLabelId].value as string
  const maxLabel = templateFieldValues[maxLabelId].value as string

  return {
    dimension: 'custom',
    properties: {
      naOption: false,
      maxRating: maxRating,
      minRating: minRating,
      minLabel: minLabel,
      maxLabel: maxLabel
    },
    grouping: [{
      percentage: {
        max: 1,
        min: 0.68
      },
      label: maxLabel
    }, {
      percentage: {
        max: 0.67,
        min: 0.33
      },
      label: 'Neutral'
    }, {
      percentage: {
        max: 0.32,
        min: 0
      },
      label: minLabel
    }]
  }
}
